<template>
  <div class="article ">
    <div class="flex-box">
        <div>
            <div class="title">大客户代表（六险一金+高底薪+高提成）</div>
            <div class="require">广州天河区 | 珠江新城 | 1-3年 | 大专 | 全职 | 招1人</div>
        </div>
        <div>
            <div class="salary">6K-10K</div>
            <div class="btn"><button @click="select">申请职位</button></div>
        </div>
    </div>
    <div class="content">
      <div class="head">岗位职责：</div>
      <br />
      1、负责开发和拓展全国范围内的银行、集团公司、企事业单位等客户，达成商业合作；<br />
      2、分析、挖掘客户需求，为客户提供专业的礼品咨询和礼品解决方案；<br />
      3、管理维护客户间的长期战略合作计划，对客户需求进行深度挖掘，达成深度合作，提升销售业绩；<br />
      4、负责销售项目管理，包括项目跟踪、谈判、签约、收款、客户关系的维护等一系列销售活动；<br />
      5、提高客户满意度；定期拜访和维系重点客户；<br />
      6、负责销售活动的策划和执行；<br />
      7、负责销售区域内客户信息收集；行业信息收集等；<br />
      <br />
      任职资格：<br />
      1、一年以上销售经验，具备礼品行业、电商行业、快消品经验者优先；具备大客户销售经验者优先；具一定客户资源者优先；<br />
      2、熟悉招投标流程，熟练制作标书等文件，具备大型项目招投标项目者优先<br />
      3、具有较强的市场开拓及销售能力，准确把握市场需求；<br />
      4、具较强的沟通能力、公关能力、抗压能力；<br />
      5、熟练使用office办公软件；具驾驶经验、熟悉路况者优先；<br />
    </div>
    <div>
      <div class="head">职位福利</div>
      <div class="welfare">
          <ul>
              <li v-for="item in welfare" :key="item">{{item}}</li>
          </ul>
      </div>
    </div>

    <div>
        <div class="head">工作地点</div>
        <div>广州市天河区珠江新城临江大道5号保利中心6楼603-604</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
        welfare:[ '五险一金', '绩效奖金', '带薪年假', '员工旅游', '餐补', '交通补助', '加班补贴', '补充医疗险' ]
    }
  },
  methods:{
      select(){

      }
  }
};
</script>
<style lang="scss" scoped>
.article {
  font-size: 0.12rem;
  color: #303030;
   
    .content{
        color: #606060;
        font-size: 0.14rem;
    }
      .head{
          font-size: 0.16rem;
          margin: 0.2rem 0;
          border-bottom:1px solid #EEEEEE ;
          padding: 0.1rem 0;
      }
      .title{
          font-size: 0.18rem;
      }
      .require{
          font-size: 0.14rem;
          color: #909090;
      }
      .welfare{
          ul{
              li{
                  display: inline-block;
                  background: #DAE6F1;
                  color: $color-blue;
                  border-radius: 30px;
                  padding: 0.01rem 0.1rem;
                  margin: 0 0.1rem;
              }
          }
      }
       .salary{
        text-align: center;
        font-size: 0.18rem;
        color: #FF4848;
     }
     .btn{
         button{
            font-size: 0.14rem;
            border: 1px solid $color-skyblue;
            color: $color-skyblue;
            border-radius: 30px;
            background: #fff;
         }
        :hover{
            cursor:pointer;
            border-color: $color-blue;
            color: $color-blue;
        }
     }
  
}
</style>
